import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { SuppliersTableRow } from '../../types/suppliersTableRow'
import { SuppliersTableNoDataField } from '../SuppliersTableNoDataField'

interface SuppliersTableEmailCellProps {
  row: SuppliersTableRow
}

export const SuppliersTableEmailCell = ({ row }: SuppliersTableEmailCellProps): ReactElement => {
  if (row.email === null || row.email === '') {
    return <SuppliersTableNoDataField />
  }

  return <Typography.Text>{row.email}</Typography.Text>
}
